
"use client";

import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import React from 'react';

const PAYPAL_CLIENT_ID = process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID;

export function PayPalContextProvider({ children }: { children: React.ReactNode }) {
  if (!PAYPAL_CLIENT_ID || PAYPAL_CLIENT_ID === "YOUR_PAYPAL_CLIENT_ID") {
    console.warn("PayPal Client ID não está configurado ou está usando o valor padrão. Os botões de pagamento não serão renderizados.");
    return <>{children}</>;
  }

  const initialOptions = {
    clientId: PAYPAL_CLIENT_ID,
    currency: "BRL",
    intent: "subscription",
    vault: true,
  };

  return (
    <PayPalScriptProvider options={initialOptions}>
      {children}
    </PayPalScriptProvider>
  );
}
